/* @flow */

export const PROTOCOL = {
    MOCK:  ('mock:' : 'mock:'),
    FILE:  ('file:' : 'file:'),
    ABOUT: ('about:' : 'about:')
};

export const WILDCARD = '*';

export const WINDOW_TYPE = {
    IFRAME: ('iframe' : 'iframe'),
    POPUP:  ('popup' : 'popup')
};



// WEBPACK FOOTER //
// ./src/constants.js